import { Box, Typography } from "@mui/material";

export default function TitleBlockCard(props: any) {
  return (
    <Box className="titleBlock">
      <Typography className="mainTitle">{props.title}</Typography>
    </Box>
  );
}